import { EntityType } from '@frontend/common';
import { AttributeClient } from '@frontend/attribute/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useAttribute:request': CustomEvent<string>;
    }
}

const REQUEST_ATTRIBUTE_EVENT = 'useAttribute:request';
const STORAGE_KEY = 'ATTR_REQ';

export function attributeRequest(attributeId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_ATTRIBUTE_EVENT, { detail: attributeId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function AttributeResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_ATTRIBUTE_EVENT, EntityType.ATTRIBUTE, (ids) => AttributeClient.resolveAttributes(ids), props.dispatch);
    return <></>;
}
